import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

const LOCAL_PART = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
const DOMAIN_LABEL = /^[A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?$/;
const TLD = /^[A-Za-z]{2,}$/;

const MAX_LENGTH = 50;

export function isValidEmail(value: string): boolean {
    if (value.length > MAX_LENGTH) return false;

    const at = value.lastIndexOf("@");
    if (at <= 0) return false;

    const local = value.slice(0, at);
    const labels = value.slice(at + 1).split(".");

    return (
        LOCAL_PART.test(local) &&
        labels.length >= 2 &&
        labels.every(label => DOMAIN_LABEL.test(label)) &&
        TLD.test(labels.at(-1) ?? "")
    );
}

export function emailValidator(): ValidatorFn {
    return (control: AbstractControl<string | null>): ValidationErrors | null => {
        const value = control.value ?? "";
        return value === "" || isValidEmail(value) ? null : { email: true };
    };
}
